<template>
    <div class="image-picker">
        <label :for="id" class="image-picker__label" v-if="label">
            <slot name="label">
                {{ label }}
            </slot>
        </label>
        <slot name="picker">
            <div class="image-picker__wrapper" :id="id">
                <div class="image-picker__selected-image">
                    <img :src="currentThumbnail" />
                </div>
                <div class="image-picker__image-list">
                    <div
                        class="image-picker__choose-image"
                        :class="{'image-picker__choose-image_selected': image.image === internalValue}"
                        v-for="image in this.imagesList"
                        :key="image.name"
                        @click="$emit('change', image.image)"
                    >
                        <img :src="image.thumbnail || image.image" />
                        <div class="image-picker__caption">{{ image.name }}</div>
                    </div>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
import {mixins} from "atom";

const {Proxyable} = mixins;

export default {
    name: "ImagePickerGroup",
    mixins: [Proxyable],
    props: {
        label: {type: String},
        id: {
            default() {
                return `${this._uid}`;
            },
        },
        imagesList: {type: Array},
    },
    computed: {
        currentThumbnail() {
            const bgObject = this.imagesList.find(img => img.image === this.internalValue);
            return bgObject?.thumbnail || this.internalValue;
        },
    },
};
</script>

<style scoped lang="scss">
.image-picker::v-deep {
    .image-picker__label {
        @apply inline-block font-bold mb-1;
    }

    .image-picker__selected-image {
        @apply inline-block relative align-top;
        width: 35%;
        img {
            @apply w-full;
        }
    }

    .image-picker__image-list {
        @apply inline-block relative text-center;
        width: 65%;

        .image-picker__choose-image {
            @apply inline-block relative mx-2 mb-4 align-top cursor-pointer;
            width: 5rem;
            img {
                @apply w-full;
            }
            .image-picker__caption {
                @apply text-center absolute bottom-0 w-full pb-1;
                font-size: $font-small;
                color: $image-picker-caption-color;
            }

            &.image-picker__choose-image_selected {
                border-bottom: 0.25rem solid $image-picker-highlight-color;
                .image-picker__caption {
                    color: $image-picker-caption-selected-color;
                }
            }
        }
    }
}
</style>
